'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _scrollSnoop = require('./scroll-snoop');

var _scrollSnoop2 = _interopRequireDefault(_scrollSnoop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var easeIntoView = function easeIntoView() {
  // Elements slide up as they come into the viewport
  var active = false;

  var isWithinBounds = function isWithinBounds() {
    var easeElements = [].slice.call(document.querySelectorAll('[data-ease-in]'));

    if (easeElements.length) {
      if (active === false) {
        active = true;

        setTimeout(function () {
          easeElements.forEach(function (element, index) {
            if ((0, _scrollSnoop2.default)(element)) {
              element.classList.add('visible');

              easeElements = easeElements.filter(function (active) {
                return active !== element;
              });
            }
          });

          active = false;
        }, 200);
      }
    }
  };

  window.addEventListener('resize', isWithinBounds);
  window.addEventListener('orientationchange', isWithinBounds);
  document.addEventListener('scroll', isWithinBounds);
  document.addEventListener('ease:update', isWithinBounds);
  document.addEventListener('bcs:product-inserted', isWithinBounds);
  isWithinBounds();
};

exports.default = easeIntoView;